/* ©2018 EdgeVerve Systems Limited (a fully owned Infosys subsidiary),
Bangalore, India. All Rights Reserved.
 */
import { Polymer, html } from '@polymer/polymer/polymer-legacy.js';
const template = html`
    <style include="app-styles">
      paper-card {
        height: fit-content !important;
        padding:24px 10% 10%;
      }
      paper-checkbox .selection-checkbox {
        --paper-checkbox-label-spacing: 0;
        --paper-checkbox-checked-color: #3CB371;
      }
      .list-search{
        padding: 0 0px 20px 0px;
      }
      .listing-filter-actions {
        padding: 0px 24px 24px;
      }
      .font-style {
        letter-spacing: 0.0025em;
      }
      .heading-sub-font {
        padding: 0px 24px 24px;
      }
      .font-color{
        color: rgb(0, 131, 155);
      }
      .redirection-text {
        font-size: 16px;
        font-weight: 700;
        color: #101214;
      }
    </style>
    <app-media-query phone="{{phone}}" desktop="{{desktop}}" tablet="{{tablet}}" notsupporteddevice={{notsupporteddevice}}></app-media-query>
    <page-title name="h_CorporateDashboard" left-action="{{leftAction}}"></page-title>
    <div class="content-align-center">
      <div class="margin-b-zero mdl-cell mdl-cell--10-col">
        <paper-card>
          <div>
            <nbb-success-screen title={{successText}} sub-title-list = {{subTitleList}} enable-button={{enableButton}} hide-reference={{hideReference}}></nbb-success-screen>
          </div>
          <div style="margin:0px 18px 0px 18px;">
            <div class="action-button-wrapper listing-items overflow-hidden mainContainer list" tabindex="0"  style="margin-bottom:1px;border:2px solid #f6f8f9;border-radius: 5px;">
              <div class$=" openedItem-{{item.openedFlag}} mdl-cell mdl-cell--12-col horizontal light-background layout list-item content-align-vertical-center " style="padding:1.2%;margin:0px 0px 1px 0px;width:-webkit-fill-available;">
                  <div class="mdl-cell mdl-cell--12-col-desktop redirection-text wrapClass1" role="cell">
                      {{getSuccessLabel()}}
                  </div>
              </div>
            </div>
            <template is="dom-if" if="{{showAccountsList}}">
              <div class="light-background shadow margin-b-zero" style="margin-bottom:2px !important;">
                <div class="mdl-cell--12-col content-align-vertical-center margin-b-zero" style="padding:2%;">
                  <iron-icon tabindex="0" icon="transfer-payment" class="secondary-dark-text-l disabled-dark-color" style="color:gray;"></iron-icon> 
                  <oe-i18n-msg class="successsummaryheading" msgid="l_reqSummary" style="padding:0px 10px"></oe-i18n-msg>
                </div>
              </div>
              <div class="listing-table-container" style="border:2px solid #f6f8f9;border-radius: 5px;">
                  <div class="mdl-grid mdl-grid--no-spacing" style="margin: 24px 24px;">
                      <div class="mdl-cell mdl-cell--12-col">
                          <div class="font-style font-24">
                              <oe-i18n-msg msgid="l_accountList" role="heading" aria-level="1"></oe-i18n-msg>
                          </div>
                      </div>
                  </div>
                  <div id="list-container" role="table">
                      <div class="content-align-vertical-center margin-b-zero mdl-grid horizontal layout font-10 secondary-color text-transform-uppercase font-weight-700" style="padding:1.2%;background-color:#FAFAFB;">   
                          <div class="mdl-cell mdl-cell--5-col">
                              <oe-i18n-msg class="acct-list-header-class" msgid="l_AccountName"></oe-i18n-msg>
                          </div>
                          <div class="mdl-cell mdl-cell--4-col">
                              <oe-i18n-msg class="acct-list-header-class" msgid="l_Account_Num"></oe-i18n-msg>
                          </div>
                          <div class="mdl-cell mdl-cell--3-col">
                              <oe-i18n-msg class="acct-list-header-class" msgid="l_Accounttype"></oe-i18n-msg>
                          </div>
                      </div>
                      <template is = "dom-repeat" items="{{displayRows}}">
                          <div class="action-button-wrapper listing-items overflow-hidden mainContainer list" tabindex="0"  style="margin-bottom:1px">
                              <div class$=" openedItem-{{item.openedFlag}} mdl-cell mdl-cell--12-col horizontal light-background layout list-item content-align-vertical-center " style="padding:1.2%;margin:0px 0px 1px 0px;width:-webkit-fill-available;">
                                  <div class="mdl-cell mdl-cell--5-col-desktop acct-list-value-class wrapClass1" role="cell">
                                      {{item.accountName}}
                                  </div>
                                  <div class="mdl-cell mdl-cell--4-col-desktop acct-list-value-class wrapClass1" role="cell">
                                      {{item.accountId}}
                                  </div>
                                  <div class="mdl-cell mdl-cell--3-col-desktop acct-list-value-class wrapClass1" role="cell">
                                      {{item.accountType.codeDescription}}
                                  </div>
                              </div>
                      </template>
                  </div>
                  <div class="pagination-margin">
                      <oe-data-table-custom-pagination rows-data="{{previewDetailsList}}" display-rows = "{{displayRows}}">
                      </oe-data-table-custom-pagination>
                  </div>
              </div>
            </template>
          </div>
        </paper-card>
      </div>
    </div>
    `;
Polymer({
  is: 'open-banking-account-consents-success',
  _template: template,
  behaviors: [corpBehaviours.appCommonBehaviour, corpBehaviours.appMenuBehaviour, corpSbBehaviour.corpAuthAndWorkflow, sbBehaviours.paginationBehaviours],
  properties: {
    selectedPage: {
      type: String,
      notify: true
    },
    userId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'userId');
      }
    },
    consentId: {
      type: String,
      value: () => {
        return clientStorage.get(storageType.session, 'openBankingConsentId');
      }
    },
    successResponse: {
      type: Array,
      notify: true,
      observer: "prepareDisplayList"
    },
    previewDetailsList: {
      type: Array,
      value: []
    },
    openBankingAccountsResponse: {
      type: Array,
      notify: true
    },
    successText: {
      type: String,
      notify: true,
      value: getLabel("l_accountCertificateDocumentRequest")
    },
    enableButton: {
      type: Boolean,
      value: false,
      notify: true
    },
    successObj: {
      type: Object,
      notify: true,
      observer: 'setSuccessMsg'
    },
    hideReference: {
      type: Boolean,
      value: true
    },
    subTitleList: {
      type: Array,
      value: [],
      notify: true
    },
    actionType: {
      type: String,
      notify: true,
      observer: "actionTypeChange"
    },
    showAccountsList: {
      type: Boolean,
      value: true
    }
  },
  formatDate: function (date) {
    return moment.utc(date).format('DD-MMM-YYYY');
  },
  prepareDisplayList() {
    if (this.successResponse && this.openBankingAccountsResponse) {
      var responseList = [];
      var self = this;
      if (self.successResponse.accountIdList && self.successResponse.accountIdList.length > 0) {
        this.openBankingAccountsResponse.forEach(item => {
          self.successResponse.accountIdList.forEach(element => {
            if (item.accountId == element.accountId) {
              if (element.accountType.cmCode == "CCD" || element.accountType.cmCode == "PCD") {
                element.accountId = this._formatCreditCard(element.accountId);
              }
              element.accountType = item.accountType;
              element.accountName = item.accountName;
              element.accountNickName = item.accountNickName;
              responseList.push(element);
            }
          });
        });
      }
      this.previewDetailsList = responseList;
      setTimeout(() => {
        window.location.href = self.successResponse.redirectionUrl;
      }, 5000);
    }
  },
  setSuccessMsg: function () {
    var self = this;
    if (this.successObj != undefined && Object.keys(this.successObj).length != 0) {
      var message = this.successObj.chennelContext.status.message;
      if (message && message.length) {
        this.subTitleList = message.map(item => {
          return item.messageDesc;
        });
      }
    }
  },
  actionTypeChange() {
    if (this.actionType && this.actionType == "APPROVE") {
      this.showAccountsList = true;
    }
    else {
      this.showAccountsList = false;
    }
  },
  getSuccessLabel() {
    return getLabel("l_openBankingRedirectionText");
  },
  _errorHandler(event) {
    showAjaxError(event);
    setTimeout(() => {
      if (clientStorage.get(storageType.session, 'backendRedirectUri')) {
        window.location.href = clientStorage.get(storageType.session, 'backendRedirectUri');
      }
    }, 3000);
  }
});
